import { createFileRoute } from '@tanstack/react-router';

import { IntegrationsApp } from 'src/apps/integrations/app/IntegrationsApp';

export const Route = createFileRoute('/_auth/_layout/integrations/')({
  component: () => <IntegrationsApp />,
});
